/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown>, period: NonNullable<unknown> }} Signup_Feature_Pro_2Inputs */



/**
* | output |
* | --- |
* | "Automatic Captioning & transcription — {minutes} mins/{period}*" |
*
* @param {Signup_Feature_Pro_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_2 = /** @type {((inputs: Signup_Feature_Pro_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
	return /** @type {LocalizedString} */ (`Automatic Captioning & transcription — ${i?.minutes} mins/${i?.period}*`)
});